import { useState, useEffect } from 'react';
import { formsApi } from '../../../services/api';
import { FormSchema } from '../../../types/form';
import { showError } from '../../../utils/toast';

interface UseFormsOptions {
  category?: string;
  search?: string;
  isActive?: boolean;
  autoFetch?: boolean;
}

export const useForms = (options: UseFormsOptions = {}) => {
  const { category, search, isActive, autoFetch = true } = options;
  const [forms, setForms] = useState<FormSchema[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchForms = async () => {
    setLoading(true);
    setError(null);
    try {
      const params: any = {};
      if (category) params.category = category;
      if (search) params.search = search;
      if (isActive !== undefined) params.isActive = isActive;
      
      const response = await formsApi.list(params);
      setForms(response.data);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to fetch forms';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      // Debounce search to avoid fetching on every keystroke
      const timeoutId = setTimeout(() => {
        fetchForms();
      }, 500); // Wait 500ms after user stops typing

      return () => clearTimeout(timeoutId);
    }
  }, [category, search, isActive, autoFetch]);

  return {
    forms,
    loading,
    error,
    refetch: fetchForms,
  };
};
